module.exports = __webpack_public_path__ + "assets/boxicons.1ec26ee17fd6b5903e74b8a599166a22.woff2";